import * as React from 'react';
import { SVGProps } from 'react';

const SvgAnnualReport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m19.99 7.593-1.007-.843a7.42 7.42 0 0 0-4.782-1.74H1.044v23.48H14.21a7.42 7.42 0 0 1 4.782 1.741l1.008.843 1.008-.843a7.42 7.42 0 0 1 4.782-1.74h13.166V5H25.79a7.42 7.42 0 0 0-4.782 1.74l-1.017.853Z"
    />
    <path
      fill="currentColor"
      d="M11.113 22.618v1.86H8.896v-1.86c-1.52-.257-2.611-1.072-3.417-2.034l1.988-1.557c.595.989 1.585 1.557 2.583 1.557 1.09 0 1.796-.687 1.796-1.493 0-.99-1.2-1.283-2.455-1.64-1.558-.45-3.436-1.136-3.436-3.38 0-1.623 1.173-2.914 2.904-3.29V9.077h2.2v1.704c1.264.238 2.143.88 2.84 1.686l-1.833 1.392c-.486-.77-1.255-1.2-2.162-1.2-.99 0-1.668.56-1.668 1.301 0 .944 1.127 1.173 2.437 1.567 1.585.495 3.482 1.237 3.482 3.509 0 1.64-1.09 3.179-3.042 3.582Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M0 32.476h14.21a7.42 7.42 0 0 1 4.782 1.74L20 35.06l1.008-.843a7.42 7.42 0 0 1 4.782-1.741H40M19.991 7.593v23.481"
    />
    <path
      fill={props.fill}
      d="M35.328 25.073h-4.554l-.027-11.8 4.58-4.59v16.39Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M27.97 25.082v-8.767m-3.49 8.767v-6.138"
    />
  </svg>
);

export default SvgAnnualReport;
